import React from 'react';
import { Link, makeStyles, Typography } from '@material-ui/core';
import { ITheme } from '../../themes/custom/ITheme';
import { useTranslation } from 'react-i18next';

interface Props {
    proofServiceLink: string;
}

const useStyles = makeStyles((theme: ITheme) => {
    return {
        title: {
            fontSize: '24px',
            lineHeight: '24px',
            weight: '300',
            marginBottom: '10px',
        },
        text: {
            fontSize: '10px',
            lineHeight: '14px',
            marginBottom: '10px',
        },
        link: {
            fontWeight: 'bold',
        },
    };
});

const ProofServiceBlock: React.FC<Props> = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { proofServiceLink } = props;

    return (
        <>
            <Typography variant="h6" className={classes.title}>
                {t('Proof service')}
            </Typography>
            <Typography variant="body1" className={classes.text}>
                {t(
                    '* If the “proof service” is purchased, the automatic printing process will be paused. This means that you allow us to make minor technical corrections when the intent is clearly visible based on our experiences. During proof, we will do a brief visual scan of your design to give you peace of mind. Additional cost will apply. '
                )}
                <Link
                    className={classes.link}
                    href={proofServiceLink}
                    target="_blank"
                    color="secondary"
                >
                    {t('More information here')}.
                </Link>
            </Typography>
        </>
    );
};

export default ProofServiceBlock;
